import { baseApi } from '@/shared/api/baseApi';
import type { AiAskRequest, AiAskResponse, AiStatus } from '../model/types';

/** Ответ ассистента приходит после нескольких обращений к модели — с запасом до минуты, как на сервере. */
const ASK_TIMEOUT_MS = 90_000;

const aiAssistantApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAiStatus: builder.query<AiStatus, void>({
      query: () => 'ai/status',
      providesTags: ['AiAssistant'],
    }),
    askAi: builder.mutation<AiAskResponse, AiAskRequest>({
      query: (body) => ({ url: 'ai/ask', method: 'POST', body, timeout: ASK_TIMEOUT_MS }),
      // Каждый вопрос тратит суточный лимит — счётчик в статусе должен обновиться.
      invalidatesTags: ['AiAssistant'],
    }),
  }),
});

export const { useGetAiStatusQuery, useAskAiMutation } = aiAssistantApi;
